import { selfAxios } from "../../../../axios/selfAxios.js";
async function getCheckWhitelistByBusinessTypeAndBusinessId(params) {
  const { data } = await selfAxios.get(`/mtdsbase/internal/whitelist/checkWhitelistByBusinessTypeAndBusinessId`, {
    params,
    _cache: true
  });
  return data == null ? void 0 : data.data;
}
export { getCheckWhitelistByBusinessTypeAndBusinessId };



// WEBPACK FOOTER //
// ./~/@oppein/op-utils/dist/es/request/internal/whitelist/checkWhitelistByBusinessTypeAndBusinessId/get.js